
export default function isOpenaiTestUser(email:string){

    const openaiIndex = email.indexOf("@openai.com")
    const punchIndex = email.indexOf("@punchline.ai")

    if(openaiIndex > -1 || punchIndex > -1) return true

    return false 
}